var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.32089 4.62667L4.84756 2.15333C4.8009 2.10667 4.7409 2.06667 4.67423 2.04C4.66756 2.04 4.6609 2.04 4.65423 2.03333C4.6009 2.01333 4.54756 2 4.48756 2C4.35423 2 4.22756 2.05333 4.13423 2.14667L1.64756 4.62667C1.45423 4.82 1.45423 5.14 1.64756 5.33333C1.8409 5.52667 2.1609 5.52667 2.35423 5.33333L3.98756 3.7V14.5C3.98756 14.7733 4.21423 15 4.48756 15C4.7609 15 4.98756 14.7733 4.98756 14.5V3.70667L6.61423 5.33333C6.71422 5.43333 6.84089 5.48 6.96756 5.48C7.09422 5.48 7.22089 5.43333 7.32089 5.33333C7.51422 5.14 7.51422 4.82667 7.32089 4.62667Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3521 11.6667C14.1588 11.4733 13.8388 11.4733 13.6455 11.6667L12.0121 13.3V2.5C12.0121 2.22667 11.7855 2 11.5121 2C11.2388 2 11.0121 2.22667 11.0121 2.5V13.2933L9.38548 11.6667C9.19215 11.4733 8.87215 11.4733 8.67881 11.6667C8.48548 11.86 8.48548 12.18 8.67881 12.3733L11.1521 14.8467C11.1988 14.8933 11.2588 14.9333 11.3255 14.96C11.3321 14.96 11.3388 14.96 11.3455 14.9667C11.3988 14.9867 11.4588 15 11.5188 15C11.6521 15 11.7788 14.9467 11.8721 14.8533L14.3521 12.3733C14.5455 12.1733 14.5455 11.86 14.3521 11.6667Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.42c49971d1a57761158b8bdf0e33a4ff.svg";
export { ForwardRef as ReactComponent };